<template>
  <ChartNormal
    size="12"
    offset="0"
    title="Received Equipment"
    chart="column"
    chartType="Received"
    :isCity="false"
    :withDate="true"
    :withFinancial="false"
  />
</template>

<script>
import ChartNormal from "../../../components/chart/chartNormal";

export default {
  name: "ReceivedEquipment",
  components: {
    ChartNormal
  }
};
</script>
